export default "__VITE_ASSET__CCqpvmgz__"